<template>
  <div
    ref="taskItem"
    v-tippy="{
      trigger: 'manual',
      placement: 'right-start',
      content: tippyContent,
      boundary: tippyBoundary,
      interactive: true,
      maxWidth: 250,
      popperOptions: {
        modifiers: [
          {
            name: 'flip',
            options: {
              boundary: tippyBoundary,
              flipVariations: true,
            },
          },
        ],
      }
    }"
    :style="{width: '100%'}"
  >
    <div
      :class="[$style['task-item']]"
      @mouseover.stop="toggleTaskTip(true)"
      @mouseleave.stop="toggleTaskTip(false)"
    >
      <div :class="[$style['task-item-name'], counter || mention ? $style['task-item-name_with_counter'] : '']">
        {{ taskName }}
      </div>

      <div :class="[$style['task-item-first-line'], 'gp_autotest_comment_hub_task_item_project_breadcrumbs']">
        <div :class="[$style['project-line']]">
          <div
            :class="[$style['breadcrumbs-icon']]"
          >
            <svg-sprite
              :name="'project'"
              :type="'regular'"
              :size="16"
            />
          </div>
          <div :class="[$style.breadcrumbs]">
            {{ shortenedBreadcrumbsIfDoesntFit.split(" > ")[0] }}
          </div>
        </div>
        <div :class="[$style['counter-block']]">
          <div
            v-if="counter && !mention"
            :class="[$style['task-item-counter'], 'gp_autotest_comment_hub_task_item_counter']"
          >
            {{ counter }}
          </div>
          <div
            v-if="mention"
            :class="[$style['task-item-counter'], 'gp_autotest_comment_hub_task_item_mention']"
          >
            <svg-sprite
              :style="{ color: '#333333'}"
              :name="'mentioned'"
              :type="'regular'"
              :size="16"
            />
          </div>
        </div>
      </div>
      <div :class="[$style['task-item-second-line'], $style.breadcrumbs, 'gp_autotest_comment_hub_task_item_path_breadcrumbs']">
        {{ (shortenedBreadcrumbsPartSecond.length ? '&nbsp;&nbsp;>&nbsp;&nbsp;' : '') + shortenedBreadcrumbsPartSecond.join('&nbsp;&nbsp;>&nbsp;&nbsp;') }}
      </div>
    </div>
  </div>
</template>

<script>

import { delay } from 'lodash';
import tooltip from '../../common/VueComponents/tooltips/tooltip.vue';
import { isBreadcrumbsFitInDiv, shortenBreadcrumbs } from '../../taskSettings/helpers/index';

export default {
  name: 'TasksItem',
  components: {
    tooltip,
  },
  props: {
    taskName: {
      type: String,
      required: true,
      default: '',
    },
    parentPath: {
      type: Array,
      required: true,
      default: [],
    },
    taskId: {
      type: Number,
      required: true,
    },
    counter: {
      type: Number,
      required: false,
    },
    mention: {
      type: Boolean,
      required: false,
    },
    hideTooltip: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      locales: __,
      isBreadcrumbsFitInDiv: false,
    };
  },
  computed: {
    tippyContent() {
      return `
        <div class="tooltip-wrapper">${this.taskName}<div class='tooltip-separator'></div>${this.parentPath.join(' > ')}</div>`;
    },
    shortenedBreadcrumbsIfDoesntFit() {
      return shortenBreadcrumbs({
        breadcrumbsArray: this.parentPath,
        separator: ' > ',
        isFit: this.isBreadcrumbsFitInDiv,

      });
    },
    shortenedBreadcrumbsPartSecond() {
      const breads = this.shortenedBreadcrumbsIfDoesntFit.split('>');

      breads.shift();

      return breads;
    },
    tippyBoundary() {
      return document.querySelector('.comment-hub-main-part');
    },
  },
  mounted() {
    delay(() => {
      this.setIsBreadcrumbsFitInDiv();
    }, 0);
  },
  methods: {
    setIsBreadcrumbsFitInDiv() {
      this.isBreadcrumbsFitInDiv = isBreadcrumbsFitInDiv({
        breadcrumbsArray: this.parentPath,
        separator: ' > ',
        classes: [this.$style.header__breadcrumbs],
        divWidth: 350,
      });
    },
    toggleTaskTip(flag) {
      const tippy = this.$refs.taskItem._tippy;

      if (this.tippyTimeout) {
        clearTimeout(this.tippyTimeout);
      }

      if (flag) {
        this.tippyTimeout = setTimeout(() => {
          tippy.show();
        }, 500);
      } else {
        this.tippyTimeout = setTimeout(() => {
          tippy.hide();
        }, 100);
      }
    },
  },
};
</script>
<style module src="../less/commentsHub.less" lang="less"></style>
<style lang="less" scoped>
.separator {
    width: 100%;
    margin: 8px 10px;
    height: 1px;
}
</style>
